import SvgIcon, {type SvgIconProps} from '@mui/material/SvgIcon';

const Delete = (props : SvgIconProps) => (
  <SvgIcon {...props}>
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 17.477 19.1">
      <g id="Groupe_35" data-name="Groupe 35" transform="translate(0.5 0.5)">
        <path id="Tracé_450" data-name="Tracé 450" d="M3,6H19.477" transform="translate(-3 -2.338)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
        <path id="Tracé_451" data-name="Tracé 451" d="M17.816,5.662V18.477a1.831,1.831,0,0,1-1.831,1.831H6.831A1.831,1.831,0,0,1,5,18.477V5.662m2.746,0V3.831A1.831,1.831,0,0,1,9.577,2h3.662a1.831,1.831,0,0,1,1.831,1.831V5.662" transform="translate(-3.169 -2)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
        <line id="Ligne_16" data-name="Ligne 16" y2="5.185" transform="translate(6.481 7.938)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
        <line id="Ligne_17" data-name="Ligne 17" y2="5.185" transform="translate(10.37 7.938)" fill="none" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="1"/>
      </g>
    </svg>
  </SvgIcon>
);

export default Delete;